"use strict";

exports.__esModule = true;
var _DashboardDataProvider = require("./DashboardDataProvider");
Object.keys(_DashboardDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardDataProvider[key]) return;
  exports[key] = _DashboardDataProvider[key];
});